import React from 'react';
import { Form, Button, InputGroup, FormControl } from 'react-bootstrap';

interface BulkLandingPageGeneratorProps {
    handleGenerate: () => void;
    LoadingModal: React.FC<{ messages: string[] }>;
    industries: string[];
    setIndustries: React.Dispatch<React.SetStateAction<string[]>>;
    services: string[];
    setServices: React.Dispatch<React.SetStateAction<string[]>>;
    statusMessages: string[];
}

const BulkLandingPageGenerator: React.FC<BulkLandingPageGeneratorProps> = ({ 
    handleGenerate, 
    LoadingModal,
    industries,
    setIndustries,
    services,
    setServices,
    statusMessages
}) => {

    const updateIndustryValue = (index: number, value: string) => {
        const updatedIndustries = [...industries];
        updatedIndustries[index] = value;
        setIndustries(updatedIndustries);

        console.log(updatedIndustries)
    };

    const updateServiceValue = (index: number, value: string) => {
        const updatedServices = [...services];
        updatedServices[index] = value;
        setServices(updatedServices);

        console.log(updatedServices)
    };

    return (
        <>
            <LoadingModal messages={statusMessages} />
            <h1>Bulk Landing Page Generator</h1>
            <Form>
                {/* Industries Inputs */}
                {industries.map((industryValue, index) => (
                    <InputGroup key={index} className="mb-3">
                        <InputGroup.Text>Industry {index + 1}</InputGroup.Text>
                        <FormControl
                            placeholder={`Enter industry ${index + 1}`}
                            value={industryValue}
                            onChange={(e) => updateIndustryValue(index, e.target.value)}
                        />
                    </InputGroup>
                ))}
                <Button
                    variant="secondary"
                    onClick={() => setIndustries(prev => [...prev, ""])}
                    className="mb-3"
                >
                    Add another industry
                </Button>

                {/* Services Inputs */}
                {services.map((serviceValue, index) => (
                    <InputGroup key={index} className="mb-3">
                        <InputGroup.Text>Service {index + 1}</InputGroup.Text>
                        <FormControl
                            placeholder={`Enter service ${index + 1}`}
                            value={serviceValue}
                            onChange={(e) => updateServiceValue(index, e.target.value)}
                        />
                    </InputGroup>
                ))}
                <Button
                    variant="secondary"
                    onClick={() => setServices(prev => [...prev, ""])}
                    className="mb-3"
                >
                    Add another service
                </Button>

                <Button variant="primary" onClick={handleGenerate}>
                    Generate Landing Pages
                </Button>
            </Form>
        </>
    );
};

export default BulkLandingPageGenerator;